import { useEffect, useState } from 'react';
import { useLocation, useNavigation } from 'react-router';

import { getCartScriptElement } from '@jane/bloom/utils/getCartScriptElement';

/**
 * Reset the cart after navigating away from the checkout page.
 */
export const useResetCartScript = () => {
  const [shouldResetCart, setShouldResetCart] = useState(false);
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    const comingFromCheckout = location.pathname.includes('checkout');
    const navigationLoading = navigation.state === 'loading';
    if (comingFromCheckout && navigationLoading) {
      // Queue up the reset for when the navigation is idle.
      setShouldResetCart(true);
    }
  }, [location.pathname, navigation.state]);

  useEffect(() => {
    const iframe = getCartScriptElement();
    const navigationIsIdle = navigation.state === 'idle';
    const resetCart = shouldResetCart && navigationIsIdle && iframe;
    if (resetCart) {
      // Reset the iframe when navigation is idle.
      iframe.src += '';
      setShouldResetCart(false);
    }
  }, [navigation.state, shouldResetCart]);
};
